import React, { Component } from 'react';
import './contentArea.css';

class ContentArea extends Component {
  displayName = "ContentArea"
  constructor(props){
    super(props);
    this.state={
      style: this.handleInit()
    }
  }
  handleInit(){
    // let rows = "";
    let columns = "";
    let style = {};
    // for(let i =0; i<this.props.rowCount;i++) rows += "minmax(0,100%) ";
    for(let i =0; i<this.props.colCount;i++) columns += "minmax(0,100%) ";
    style={
      display: 'grid',
      //height: '100%',
      //minHeight: '100%',
      gridTemplateColumns: columns,
      // gridTemplateRows: rows,
      gridAutoRows: 'min-content',
      msGridColumns: columns,
      // msGridRows: rows
    }
    if(this.props.row || this.props.column){
      style = {
        ...style, 
        msGridRow: this.props.row,
        msGridColumn: this.props.column,
        msGridColumnSpan: this.props.colSpan,
        msGridRowSpan: this.props.rowSpan,
        gridRow: `${this.props.row} ${this.props.rowSpan ? `/ span ${this.props.rowSpan}` : ""}`,
        gridColumn: `${this.props.column} ${this.props.colSpan ? `/ span ${this.props.colSpan}` : ""}`
      }
    }
    return style;
  }
  componentDidUpdate(prevProps){
    if(prevProps.rowCount !== this.props.rowCount || prevProps.colCount !== this.props.colCount)
      this.setState({style: this.handleInit()});
  }
  render() {
    return (
      <div id={this.props.id} style={this.state.style} className={`content-area ${this.props.className}`}>
        {this.props.children}
      </div>
    );
  }
}
ContentArea.defaultProps={
  className: '',
  rowCount: 1,
  colCount: 1
}
export default ContentArea;